export default "__VITE_ASSET__CKNUaau6__"